import { ActionMeta } from "react-select5";
import { Option, encodeValue } from "../../../utils";
import { filterOptionDefault } from "@bonliva-crm/ui";

export const onCollapse =
  (collapsedGroups: string[], setCollapsedGroups: (groups: string[]) => void) =>
  (option: Option) => {
    const parent = option.parent ?? option.value.split("|||")[0];
    if (collapsedGroups.some((x) => x === parent)) {
      setCollapsedGroups([...collapsedGroups.filter((x) => x !== parent)]);
    } else {
      collapsedGroups.push(parent);
      setCollapsedGroups([...collapsedGroups]);
    }
  };

export const isGroupSelected =
  (value: string[], allOpt: Option[], full: boolean) => (option: Option) => {
    if (!value || value?.length === 0) return false;

    const parent = option.parent ?? option.value.split("|||")[0];
    // console.log("parent", parent, option);
    // x.value.startsWith(`${parent}|||`)
    const allParentOptions = allOpt
      .filter((x) => x.value.startsWith(`${parent}|||`) || x.parent === parent)
      .map((x) => x.value);

    // console.log("allParentOptions", allParentOptions);
    if (allParentOptions.length > 0) {
      if (full && allParentOptions?.every((v) => value.includes(v))) {
        return true;
      }

      if (!full && allParentOptions?.some((v) => value.includes(v))) {
        return true;
      }
    }

    return value?.some((v) => v === option.value);
  };

export const filterOption =
  (collapsedGroups: string[]) => (option: Option, inputValue?: string) => {
    if (inputValue) {
      return filterOptionDefault(option, inputValue);
    }
    const parent = option.parent ?? option.value.split("|||")[0];
    if (option.value === `${parent}|||*`) {
      return true;
    } else if (option.value === parent) {
      return true;
    } else if (!option.value.includes("|||") && !option.parent) {
      return true;
    }

    return collapsedGroups.some((x) => x === parent);
  };

export const isCollapsible = (option: Option) =>
  !option.value.includes("|||") && !option.parent;

export const isCollapsed = (collapsedGroups: string[]) => (option: Option) => {
  const parent = option.parent ?? option.value.split("|||")[0];

  return !collapsedGroups.some((x) => x === parent);
};

export const isOptionStandAlone = (options: Option[]) => (option: Option) => {
  return (
    !option.value.includes("|||") &&
    !option.parent &&
    !options.some((x) => x.value.startsWith(option.value) && x.value !== option.value) &&
    !options.some((x) => x.parent === option.value)
  );
};

export const baseOnChange =
  (allOptions: Option[], onChange: (v: Option[]) => void) =>
  (_newValues: Option[], actionMeta: ActionMeta<Option>) => {
    const { action, option } = actionMeta;
    let finalValues = _newValues;

    if (action === "select-option") {
      const parent = option.parent ?? option.value.split("|||")[0];

      const allParentOptions = allOptions.filter(
        (x) => x.value.startsWith(`${parent}|||`) || x.parent === parent
      );
      if (option.value === `${parent}`) {
        finalValues = [
          ...(_newValues.filter((x) => x.value !== parent) ?? []),
          ...allParentOptions
        ];
      } else {
        finalValues.push(option);
      }
    }

    if (action === "deselect-option") {
      const parent = option.parent ?? option.value.split("|||")[0] ?? option.value;
      if (option.value === `${parent}`) {
        finalValues = _newValues.filter(
          (x) =>
            !x.value.startsWith(`${parent}|||`) &&
            x.parent !== parent &&
            !x.value.includes(`(${parent})`)
        );
      }
    }

    onChange(finalValues.uniqueBy((x) => x.value));
  };

export const commonCollapsibleProps = {
  isCollapsible,
  hideSelectedOptions: false,
  controlShouldRenderValue: true,
  isSearchable: true,
  maxMenuHeight: 400,
  closeMenuOnSelect: false,
  menuPlacement: "bottom" as const,
  // menuChildrenPosition: "top" as const,
  // menuPortalTarget: document.body,
  styleProps: {
    menu: {
      // menuPortal: { zIndex: 9999 },
      // position: "absolute" as const,
      showBorder: true
    }
  }
};

export function parseMethod(specialization: string) {
  if (!specialization.includes("(")) {
    return {
      label: specialization,
      value: specialization
    };
  }

  const [name, firstOccur, secondOccur] = specialization
    .slice(0, specialization.length - 1)
    .split(" (");
  // const label = secondOccur ? `${name} (${firstOccur}` : name;

  return {
    label: name,
    value: specialization,
    parent: secondOccur ?? firstOccur
  };
}

export function parseSpec(specialization: string) {
  if (!specialization.includes("(")) {
    return {
      label: specialization,
      value: encodeValue("Psykolog", specialization)
    };
  }

  // eslint-disable-next-line prefer-const
  let [name, parent, mayBeParent] = specialization
    .slice(0, specialization.length - 1)
    .split(" (");

  if (mayBeParent) {
    name = `${name} (${parent}`;
    parent = mayBeParent;
  }

  return {
    label: name,
    value: encodeValue(parent, specialization)
  };
}
